import $ from "jquery";

const searchfilterhelpers = {
    $filtername: null,
    filter(filtername, search) {
        this.$filtername = $(filtername);
        this.disableScrollBinders();
        this.$filtername.each((index, value) => {
            let item = $(value);
            let name = item.data("name").toLowerCase();
            search = search.trim().toLowerCase();
            item.css("display", name.includes(search) ? "block" : "none");
        });
        this.enableScrollBinders();
    },
    disableScrollBinders() {
        window.menuShrinker.shrinkListenerBinder("off");
    },
    enableScrollBinders() {
        window.menuShrinker.shrinkListenerBinder("on");
    },
};
window.searchfilterhelpers = searchfilterhelpers;

const searchfiltermobile = {
    reset() {
        searchViewEs6.reset();
        $(".category-content").each((i, item) => {
            $(item).hide();
        });
    },
    init() {
        $(".category-header").on("click", ({ target }) => {
            $(target)
                .closest(".category")
                .children(".category-header")
                .toggleClass("active");
            $(target)
                .closest(".category")
                .children(".category-content")
                .toggle();
        });
        $("#brand-search-mobile").on("input", ({ target }) => {
            let search = target.value;
            searchfilterhelpers.filter(".brandfilter", search);
        });
        $("#type-search-mobile").on("input", ({ target }) => {
            let search = target.value;
            searchfilterhelpers.filter(".typefilter", search);
        });
        $(".taggroup-search-mobile").on("input", ({ target }) => {
            let search = target.value;
            let id = $(target).data("id");
            searchfilterhelpers.filter(
                `.tagfilter[data-taggroupid=${id}]`,
                search,
            );
        });
    },
};
window.searchfiltermobile = searchfiltermobile;

const searchfilter = {
    reset() {
        searchViewEs6.reset();
    },
    init() {
        $("#brand-search").on("input", ({ target }) => {
            let search = target.value;
            searchfilterhelpers.filter(".brandfilter", search);
        });
        $("#type-search").on("input", ({ target }) => {
            let search = target.value;
            searchfilterhelpers.filter(".typefilter", search);
        });
        $(".taggroup-search").on("input", ({ target }) => {
            let search = target.value;
            let id = $(target).data("id");
            searchfilterhelpers.filter(
                `.tagfilter[data-taggroupid=${id}]`,
                search,
            );
        });
    },
};
window.searchfilter = searchfilter;

let searchViewEs6 = {
    api_url: "/json/search?",
    brands_enabled: true,
    types_enabled: true,
    extras_enabled: true,
    genders_enabled: true,
    selected_outlet: [],
    selected_sections: [],
    selected_categories: [],
    selected_subcategories: [],
    selected_brands: [],
    selected_series: [],
    selected_ids: [],
    selected_term: "",
    selected_types: [],
    selected_tags: [],
    selected_extras: [],
    selected_genders: [],
    selected_sort: 1,

    products: [],
    brands: [],
    types: [],
    extras: [],
    tags: [],
    genders: [],

    available_brands: [],
    available_types: [],
    available_extras: [],
    available_tags: [],
    available_genders: [],

    dermaOnly: false,
    premiumOnly: false,
    minMemberPrice: null,
    maxMemberPrice: null,

    total: Number,
    pageSize: Number,
    pageCount: Number,
    page: Number,
    sort: Number,
    term: String,

    isLoading: false,

    loading() {
        return this.isLoading;
    },
    setLoading(loading) {
        this.isLoading = loading;
        let loader = $("#search-view .logo-loader");
        if (loading) {
            loader.show();
            $("#grid").addClass("loading");
        } else {
            loader.hide();
            $("#grid").removeClass("loading");
        }
    },
    buildPageUrl(pageNumber) {
        let params = [];

        params.push({ name: "page", value: pageNumber });

        let queryString = this.buildQueryString(params);
        return `${location.pathname}?${queryString}`;
    },
    buildQueryString(params) {
        let url = "";
        params.forEach(({ value, name }) => {
            if (value !== "") {
                url = url.concat(`&${name}=${value}`);
            }
        });
        return url.substr(1);
    },
    buildQuery() {
        let params = [];

        params.push({ name: "html", value: "true" });
        params.push({ name: "sections", value: this.selected_sections.join() });
        params.push({
            name: "categories",
            value: this.selected_categories.join(),
        });
        params.push({
            name: "subcategories",
            value: this.selected_subcategories.join(),
        });
        params.push({ name: "series", value: this.selected_series.join() });
        params.push({ name: "brands", value: this.selected_brands.join() });
        params.push({ name: "types", value: this.selected_types.join() });
        params.push({ name: "tags", value: this.selected_tags.join() });
        params.push({ name: "extras", value: this.selected_extras.join() });
        params.push({ name: "genders", value: this.selected_genders.join() });
        params.push({ name: "premiumOnly", value: this.premiumOnly });
        params.push({ name: "dermaOnly", value: this.dermaOnly });

        if (this.minMemberPrice != null) {
            params.push({ name: "minMemberPrice", value: this.minMemberPrice });
        }

        if (this.maxMemberPrice != null) {
            params.push({ name: "maxMemberPrice", value: this.maxMemberPrice });
        }

        if (this.term != null) {
            params.push({ name: "term", value: this.term });
        }

        if (this.selected_outlet) {
            params.push({ name: "outlet", value: this.selected_outlet });
        }

        params.push({ name: "page", value: this.page });
        params.push({ name: "sort", value: this.sort });

        let url = this.buildQueryString(params);
        return this.api_url.concat(url);
    },
    updateHistory() {
        let params = [];

        if (this.brands_enabled) {
            params.push({ name: "brands", value: this.selected_brands.join() });
        }

        if (this.types_enabled) {
            params.push({ name: "types", value: this.selected_types.join() });
        }

        params.push({ name: "tags", value: this.selected_tags.join() });

        if (this.extras_enabled) {
            params.push({ name: "extras", value: this.selected_extras.join() });
        }

        if (this.genders_enabled) {
            params.push({
                name: "genders",
                value: this.selected_genders.join(),
            });
        }

        if (this.sort > 0) params.push({ name: "sort", value: this.sort });

        params.push({ name: "page", value: this.page });

        let queryString = this.buildQueryString(params);

        if (queryString !== "") queryString = `?${queryString}`;

        history.replaceState(
            window.history.state,
            "",
            `${location.pathname}${queryString}`,
        );
    },
    query(success, error) {
        let $this = this;
        $this.setLoading(true);
        let url = $this.buildQuery();

        $.post(url, {
            ids: JSON.stringify($this.selected_ids),
            _token: CSRF_TOKEN,
        })
            .done((response) => {
                $this.setLoading(false);
                if (success !== undefined) success(response);
                $this.updateHistory();
            })
            .fail((e) => {
                $this.setLoading(false);
                if (error !== undefined) error(e);
            });
    },
    hasNextPage() {
        return this.page < this.pageCount;
    },
    hasPreviousPage() {
        return this.page > 1;
    },
    array_value_exists(arr, field, value) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i][field] === value) {
                return true;
            }
        }
        return false;
    },
    array_find(arr, field, value) {
        for (let item of arr) {
            if (item[field] === value) {
                return item;
            }
        }

        return null;
    },
    lookupTag(arr, id) {
        for (let i = 0; i < arr.length; i++) {
            for (let tag of arr[i].tags) {
                if (tag["id"] === id) {
                    return tag;
                }
            }
        }
        return null;
    },
    isBrandAvailable(id) {
        return this.array_value_exists(this.available_brands, "brandId", id);
    },
    isTypeAvailable(id) {
        return this.array_value_exists(
            this.available_types,
            "productTypeId",
            id,
        );
    },
    isExtraAvailable(id) {
        return this.array_value_exists(this.available_extras, "id", id);
    },
    isTagAvailable(id) {
        return this.lookupTag(this.available_tags, id) != null;
    },
    isGenderAvailable(id) {
        return this.available_genders.includes(id);
    },
    getBrand(id) {
        return this.array_find(this.brands, "brandId", id);
    },
    getType(id) {
        return this.array_find(this.types, "productTypeId", id);
    },
    getTag(id) {
        return this.lookupTag(this.tags, id);
    },
    getExtra(id) {
        return this.array_find(this.extras, "id", id);
    },
    getGender(id) {
        return this.genders[this.genders.indexOf(id)];
    },
    isBrandSelected(id) {
        return this.selected_brands.includes(id);
    },
    isTagSelected(id) {
        return this.selected_tags.includes(id);
    },
    isTypeSelected(id) {
        return this.selected_types.includes(id);
    },
    isExtraSelected(id) {
        return this.selected_extras.includes(id);
    },
    isGenderSelected(id) {
        return this.selected_genders.includes(id);
    },
    updateProducts(products) {
        $("#grid").html(products);
        misc.lazyload();
        window.luxTooltips.init();
    },
    clearProducts(products) {
        $("#grid").html("");
    },
    getPage() {
        let $this = this;
        $this.scrollToTop();

        this.query(
            ({ products }) => {
                $this.updateProducts(products);
                $this.updatePagers();
            },
            (error) => {},
        );
    },
    previousPage() {
        if (this.loading()) return;

        if (!this.hasPreviousPage()) return;

        this.page--;

        this.getPage();
    },

    nextPage() {
        if (this.loading()) return;

        if (!this.hasNextPage()) return;
        this.page++;

        this.getPage();
    },
    updateFilters() {
        $(".filters").each((i, item) => {
            let container = $(item);

            let selected = container.children(".item-selected");
            let available = container.children(".item-available");
            let disabled = container.children(".item-disabled");

            selected.detach();
            available.detach();
            disabled.detach();

            container.append(
                selected.sort((a, b) =>
                    $(b).data("sort") < $(a).data("sort") ? 1 : -1,
                ),
            );
            container.append(
                available.sort((a, b) =>
                    $(b).data("sort") < $(a).data("sort") ? 1 : -1,
                ),
            );
            container.append(
                disabled.sort((a, b) =>
                    $(b).data("sort") < $(a).data("sort") ? 1 : -1,
                ),
            );

            let category = container.closest(".category");
            if (category !== undefined) {
                let filterinfo = category.find(".filter-info");
                if (filterinfo !== undefined) {
                    let info = filterinfo.data("format");
                    if (info !== undefined) {
                        let total = available.length + disabled.length;
                        info = info.replace("{available}", available.length);
                        info = info.replace("{total}", total);
                        filterinfo.html(info);
                    }
                }
            }
        });
    },
    setItemDefault(item) {
        $(item).removeClass("item-disabled item-available item-selected");
    },
    setItemDisabled(item) {
        this.setItemDefault(item);
        $(item).addClass("item-disabled");
    },
    setItemAvailable(item) {
        this.setItemDefault(item);
        $(item).addClass("item-available");
    },
    setItemSelected(item) {
        this.setItemDefault(item);
        $(item).addClass("item-selected");
        $(item)
            .parents(".filter-group-wrapper")
            .addClass("filter-group-active");
    },

    updateTypes() {
        if (!this.types_enabled) return;
        $(".typefilter").each((i, item) => {
            let id = $(item).data("id");
            if (this.isTypeSelected(id)) {
                return this.setItemSelected(item);
            }
            if (this.isTypeAvailable(id)) {
                return this.setItemAvailable(item);
            }
            this.setItemDisabled(item);
        });
    },

    updateBrands() {
        if (!this.brands_enabled) return;
        $(".brandfilter").each((i, item) => {
            let id = $(item).data("id");
            if (this.isBrandSelected(id)) {
                this.setItemSelected(item);
            } else {
                this.setItemAvailable(item);
            }
        });
    },
    updateTags() {
        $(".tagfilter").each((i, item) => {
            let id = $(item).data("id");
            if (this.isTagSelected(id)) {
                return this.setItemSelected(item);
            }
            if (this.isTagAvailable(id)) {
                return this.setItemAvailable(item);
            }
            this.setItemDisabled(item);
        });
    },
    updateExtras() {
        if (!this.extras_enabled) return;
        $(".extrafilter").each((i, item) => {
            let id = $(item).data("id");
            if (this.isExtraSelected(id)) {
                return this.setItemSelected(item);
            }
            if (this.isExtraAvailable(id)) {
                return this.setItemAvailable(item);
            }
            this.setItemDisabled(item);
        });
    },
    updateGenders() {
        if (!this.genders_enabled) return;
        $(".genderfilter").each((i, item) => {
            let id = $(item).data("id");
            if (this.isGenderSelected(id)) {
                return this.setItemSelected(item);
            }
            if (this.isGenderAvailable(id)) {
                return this.setItemAvailable(item);
            }
            this.setItemDisabled(item);
        });
    },
    updateInfo() {
        $(".product-count").each((i, item) => {
            let info = $(item).data("format");
            info = info.replace("{total}", this.total);
            $(item).html(info);
        });
    },
    hidePagers() {
        $(".pager").each((i, item) => {
            $(item).hide();
        });
    },
    updatePagers() {
        $(".page-info").each((i, item) => {
            let info = $(item).data("format");
            info = info.replace("{page}", this.page);
            info = info.replace("{pageCount}", this.pageCount);
            $(item).html(info);
        });
        $(".pager").each((i, item) => {
            if (this.hasPreviousPage() || this.hasNextPage())
                $(item).css("display", "flex");
            else $(item).hide();
        });
        $(".previous-page, .previous-page-elastic").each((i, item) => {
            if (this.hasPreviousPage()) {
                $(item).css("display", "flex");
                $(item).attr("href", this.buildPageUrl(this.page - 1));
            } else {
                $(item).css("display", "none");
                $(item).removeAttr("href");
            }
        });
        $(".next-page, .next-page-elastic").each((i, item) => {
            if (this.hasNextPage()) {
                $(item).css("display", "flex");
                $(item).attr("href", this.buildPageUrl(this.page + 1));
            } else {
                $(item).css("display", "none");
                $(item).removeAttr("href");
            }
        });
    },
    createBadge(name, func) {
        return $(
            `<span class="lux-filter-btn" onclick="${func}">${name}<span class="filter-delete svg-filter-luxplus"></span></span>`,
        );
    },
    updateSelectedFilters() {
        let selectedfilters = $(".selected-filters");
        let selectedfilterscount = $(".selected-filters-count");
        let total = 0;
        selectedfilters.each((i, item) => {
            total = 0;
            let filters = $(item);
            let container = filters.find(".selected-filters-container");

            container.html("");
            if (this.brands_enabled) {
                this.selected_brands.forEach((id) => {
                    let brand = this.getBrand(id);
                    if (brand) {
                        let badge = this.createBadge(
                            brand.brandName,
                            `searchview.toggleBrand(${id})`,
                        );
                        container.append(badge);
                    }
                    total++;
                });
            }

            if (this.types_enabled) {
                this.selected_types.forEach((id) => {
                    let type = this.getType(id);
                    let badge = this.createBadge(
                        type.productTypeName,
                        `searchview.toggleType(${id})`,
                    );
                    container.append(badge);
                    total++;
                });
            }

            this.selected_tags.forEach((id) => {
                let type = this.getTag(id);
                let badge = this.createBadge(
                    type.translation.name,
                    `searchview.toggleTag(${id})`,
                );
                container.append(badge);
                total++;
            });

            if (this.extras_enabled) {
                this.selected_extras.forEach((id) => {
                    let extra = this.getExtra(id);
                    let badge = this.createBadge(
                        extra.name,
                        `searchview.toggleExtra(${id})`,
                    );

                    if ($(".page-stock").length) {
                        badge.addClass("d-none");
                    }

                    container.append(badge);
                    total++;
                });
            }

            if (this.genders_enabled) {
                this.selected_genders.forEach((id) => {
                    let gender = this.getGender(id);
                    let genderName = $(`a.genderfilter[data-id=${id}]`).attr(
                        "data-name",
                    );
                    let badge = this.createBadge(
                        genderName,
                        `searchview.toggleGender('${gender}')`,
                    );
                    container.append(badge);
                    total++;
                });
            }

            if (
                ($(".page-stock").length && this.extras_enabled && total > 1) ||
                (!$(".page-stock").length && total > 0)
            ) {
                filters.show();
            } else {
                filters.hide();
            }
        });

        let info = selectedfilterscount.data("format");
        if (info) {
            info = info.replace("{count}", total);
            selectedfilterscount.html(info);
        }

        if (total > 0) {
            selectedfilterscount.show();
        } else {
            selectedfilterscount.hide();
        }
    },
    updateUI() {
        this.updateBrands();
        this.updateExtras();
        this.updateTypes();
        this.updateTags();
        this.updateGenders();
        this.updateSelectedFilters();
        this.updateFilters();
        this.updateInfo();
        this.updatePagers();
    },
    changed() {
        this.hidePagers();
        this.clearProducts();
        this.updateSelectedFilters();

        $(".categories-wrapper").removeClass("active");
        $(".category-wrapper.expanded .submenu-wrapper").slideUp();
        $(".category-wrapper").removeClass(
            "active expanded active-menu-parent",
        );

        this.page = 1;
        this.pageCount = 1;

        let $this = this;
        this.query(
            (response) => {
                $this.total = response.total;
                $this.pageCount = response.pageCount;

                $this.available_brands = response.availableBrands;
                $this.available_extras = response.availableExtras;
                $this.available_tags = response.availableTags;
                $this.available_types = response.availableTypes;
                $this.available_genders = response.availableGenders;

                $this.updateProducts(response.products);
                $this.updateUI();
            },
            (error) => {},
        );
    },
    scrollToTop() {
        let headerHeight = $("header").outerHeight();
        let p = $("#search-view");

        $("html, body").animate(
            {
                scrollTop: $(p).offset().top - headerHeight - 24,
            },
            250,
        );
    },
    setSort(id) {
        if (this.loading()) return;

        this.sort = id;
        this.changed();
    },
    toggle(arr, id) {
        if (this.loading()) return;

        let index = arr.indexOf(id);
        if (index !== -1) {
            arr.splice(index, 1);
        } else {
            arr.push(id);
        }
        this.changed();
    },
    toggleBrand(id) {
        this.toggle(this.selected_brands, id);
    },
    toggleType(id) {
        if (this.isTypeAvailable(id) || this.isTypeSelected(id)) {
            this.toggle(this.selected_types, id);
        }
    },
    toggleTag(id) {
        if (this.isTagAvailable(id) || this.isTagSelected(id)) {
            this.toggle(this.selected_tags, id);
        }
    },
    toggleExtra(id) {
        if (this.isExtraAvailable(id) || this.isExtraSelected(id)) {
            this.toggle(this.selected_extras, id);
        }
    },
    toggleGender(id) {
        if (this.isGenderAvailable(id) || this.isGenderSelected(id)) {
            this.toggle(this.selected_genders, id);
        }
    },
    reset() {
        if (this.types_enabled) this.selected_types = [];
        if (this.brands_enabled) {
            this.selected_brands = [];
        }

        this.selected_tags = [];

        if (this.extras_enabled && !$(".page-stock").length) {
            this.selected_extras = [];
        }

        if (this.genders_enabled) this.selected_genders = [];
        this.sort = 0;
        this.changed();
    },
    init() {
        this.sort = this.selected_sort;
        this.term = this.selected_term;

        $(".extrafilter").on("click", ({ target }) => {
            searchViewEs6.toggleExtra($(target).data("id"));
        });
        $(".brandfilter").on("click", function (e) {
            e.preventDefault();
            const id = $(this).data("id");
            searchViewEs6.toggleBrand(id);
        });
        $(".typefilter").on("click", ({ target }) => {
            searchViewEs6.toggleType($(target).data("id"));
        });
        $(".submenu-list .tag").on("click", function () {
            $("html, body").animate(
                {
                    scrollTop: $("#landing-page-products").offset().top,
                },
                500,
            );

            searchViewEs6.toggleTag($(this).data("id"));
        });
        $(".tagfilter").on("click", ({ target }) => {
            searchViewEs6.toggleTag($(target).data("id"));
        });
        $(".genderfilter").on("click", ({ target }) => {
            searchViewEs6.toggleGender($(target).data("id"));
        });
        $(".next-page").on("click", (event) => {
            event.preventDefault();
            searchViewEs6.nextPage();
        });
        $(".previous-page").on("click", (event) => {
            event.preventDefault();
            searchViewEs6.previousPage();
        });
        $("#products-sorting").on("change", ({ target }) => {
            searchViewEs6.setSort($(target).val());
        });
        $(".reset-filter").on("click", (e) => {
            searchViewEs6.reset();
        });
        this.updateUI();

        /* -------------------- Search filters -------------------- */
        $(document).ready(() => {
            searchViewFiltersHeight();
            searchViewHideExtraFilters();
            searchViewShowExtraToggle();
            searchViewWrapFilters();
        });

        const searchViewFilterGroups = $(
            "#search-filter-desktop .filters-container > div.filter-group-wrapper",
        ).length;

        const searchViewToggleFilter = function (e) {
            e.stopPropagation();
            $("#search-filter-desktop .filter-group-wrapper")
                .not($(this).parents(".filter-group-wrapper"))
                .removeClass("active")
                .children(".filters-content")
                .slideUp();
            $(this).parents(".filter-group-wrapper").toggleClass("active");

            if ($(this).parents(".filter-group-wrapper").hasClass("active")) {
                $(this).siblings(".filters-content").slideDown();

                $(window).on("click", ({ target }) => {
                    if (
                        $(target).closest(
                            "#search-filter-desktop .filter-group-wrapper .filters-content, .toggle-extra-filters",
                        ).length > 0
                    ) {
                        return;
                    } else {
                        closeFilters();
                    }
                });
            } else {
                $(this).siblings(".filters-content").slideUp();
            }
        };

        const closeFilters = () => {
            $(
                "#search-filter-desktop .filter-group-wrapper .filters-content",
            ).slideUp();
            $("#search-filter-desktop .filter-group-wrapper").removeClass(
                "active",
            );
            $(window).off("click");
        };

        const searchViewToggleExtraFilters = function () {
            $(this)
                .parents(".toggle-extra-filters-wrapper")
                .toggleClass("active");
            $(
                "#search-filter-desktop .extra-filters-container .filter-group-wrapper",
            )
                .removeClass("active")
                .children(".filters-content")
                .slideUp();

            if (
                $(this)
                    .parents(".toggle-extra-filters-wrapper")
                    .hasClass("active")
            ) {
                $(this).attr("aria-label", "Close filters");
                $("#search-filter-desktop .extra-filters-container").slideDown({
                    start() {
                        $(this).css("display", "grid");
                    },
                });
            } else {
                $(this).attr("aria-label", "Expand filters");
                $("#search-filter-desktop .extra-filters-container").slideUp();
            }
        };

        const searchViewShowExtraToggle = () => {
            if (
                ($(window).width() >= 1724 && searchViewFilterGroups > 7) ||
                ($(window).width() >= 1250 &&
                    $(window).width() < 1724 &&
                    searchViewFilterGroups > 6) ||
                ($(window).width() < 1250 && searchViewFilterGroups > 4)
            ) {
                $("#search-filter-desktop .toggle-extra-filters-wrapper")
                    .removeClass("d-none")
                    .addClass("d-block");
            } else {
                $("#search-filter-desktop .toggle-extra-filters-wrapper")
                    .removeClass("d-block")
                    .addClass("d-none");
            }
        };

        const searchViewFiltersHeight = () => {
            $(
                "#search-filter-desktop .filter-group-wrapper .filters-content",
            ).each(function () {
                const filtersHeight = $(this).outerHeight();

                $(this).css({
                    height: `${filtersHeight}px`,
                    visibility: "initial",
                    display: "none",
                });
            });
        };

        const searchViewHideExtraFilters = () => {
            $("#search-filter-desktop .extra-filters-container").css({
                height: "auto",
                overflow: "initial",
                display: "none",
            });
        };

        const searchViewWrapFilters = () => {
            if ($(window).width() >= 1724 && searchViewFilterGroups > 6) {
                if ($(".filter-categories-container.expanded").length) {
                    $(
                        "#search-filter-desktop .filters-container .filter-group-wrapper:nth-child(1n+7)",
                    ).wrapAll("<div class='extra-filters-container'></div>");
                    $(
                        "#search-filter-desktop .extra-filters-container",
                    ).insertAfter("#search-filter-desktop .filters-container");
                } else {
                    $(
                        "#search-filter-desktop .filters-container .filter-group-wrapper:nth-child(1n+8)",
                    ).wrapAll("<div class='extra-filters-container'></div>");
                    $(
                        "#search-filter-desktop .extra-filters-container",
                    ).insertAfter("#search-filter-desktop .filters-container");
                }
            } else if (
                $(window).width() >= 1250 &&
                searchViewFilterGroups > 5
            ) {
                if ($(".filter-categories-container.expanded").length) {
                    $(
                        "#search-filter-desktop .filters-container .filter-group-wrapper:nth-child(1n+6)",
                    ).wrapAll("<div class='extra-filters-container'></div>");
                    $(
                        "#search-filter-desktop .extra-filters-container",
                    ).insertAfter("#search-filter-desktop .filters-container");
                } else {
                    $(
                        "#search-filter-desktop .filters-container .filter-group-wrapper:nth-child(1n+7)",
                    ).wrapAll("<div class='extra-filters-container'></div>");
                    $(
                        "#search-filter-desktop .extra-filters-container",
                    ).insertAfter("#search-filter-desktop .filters-container");
                }
            } else if ($(window).width() < 1250 && searchViewFilterGroups > 4) {
                if ($(".filter-categories-container.expanded").length) {
                    $(
                        "#search-filter-desktop .filters-container .filter-group-wrapper:nth-child(1n+4)",
                    ).wrapAll("<div class='extra-filters-container'></div>");
                    $(
                        "#search-filter-desktop .extra-filters-container",
                    ).insertAfter("#search-filter-desktop .filters-container");
                } else {
                    $(
                        "#search-filter-desktop .filters-container .filter-group-wrapper:nth-child(1n+5)",
                    ).wrapAll("<div class='extra-filters-container'></div>");
                    $(
                        "#search-filter-desktop .extra-filters-container",
                    ).insertAfter("#search-filter-desktop .filters-container");
                }
            }
        };

        const searchViewFiltersResize = () => {
            $("#search-filter-desktop .extra-filters-container").appendTo(
                "#search-filter-desktop .filters-container",
            );
            $(
                "#search-filter-desktop .extra-filters-container .filter-group-wrapper",
            ).unwrap();
            $("#search-filter-desktop .filter-group-wrapper").removeClass(
                "active",
            );
            $(
                "#search-filter-desktop .filter-group-wrapper .filters-content",
            ).slideUp();

            searchViewWrapFilters();

            if (
                $(
                    "#search-filter-desktop .toggle-extra-filters-wrapper",
                ).hasClass("active")
            ) {
                $("#search-filter-desktop .extra-filters-container").css({
                    height: "auto",
                    overflow: "initial",
                });
            } else {
                searchViewHideExtraFilters();
            }
        };

        function debounce(func) {
            let timer;
            return (event) => {
                if (timer) clearTimeout(timer);
                timer = setTimeout(func, 100, event);
            };
        }

        $("#search-filter-desktop .filter-group-wrapper h4").on(
            "click",
            searchViewToggleFilter,
        );
        $(".toggle-extra-filters").on("click", searchViewToggleExtraFilters);
        $(".filter-categories-container .categories-title").on(
            "click",
            searchViewFiltersResize,
        );
        searchViewWrapFilters();

        let headerHeight = $("header").outerHeight();
        let topBarHeight = "0";
        let productGridWrapper = $(".product-grid-wrapper");

        if ($(".top-bar").length) {
            topBarHeight = $(".top-bar").outerHeight();
        }

        if (productGridWrapper.length) {
            var productGridTop = $(".product-grid-wrapper").offset().top;
            var productGridHeight = $(".product-grid-wrapper").height();
            var stickyFiltersTop = productGridTop - headerHeight - topBarHeight;
        }

        $(".filter-categories").css("--header-height", `${headerHeight}px`);

        $(window).scroll(
            debounce((e) => {
                headerHeight = $("header").outerHeight();
                $(".filter-categories").css(
                    "--header-height",
                    `${headerHeight}px`,
                );
            }),
            function () {
                if (productGridWrapper.length) {
                    if (
                        $(window).scrollTop() > stickyFiltersTop &&
                        $(window).scrollTop() <
                            productGridHeight + stickyFiltersTop
                    ) {
                        $(".sticky-filters .btn-mobile-filter").addClass(
                            "show",
                        );
                    } else {
                        $(".sticky-filters .btn-mobile-filter").removeClass(
                            "show",
                        );
                    }
                }
            },
        );

        window.addEventListener(
            "resize",
            debounce((e) => {
                searchViewFiltersResize();
                searchViewShowExtraToggle();
            }),
        );
    },
};
window.searchview = searchViewEs6;
